module.exports = __webpack_public_path__ + "img/heading_latest.eb4685be.png";